export default function convertTrackPointToWaypoint(localId: string, track: Track): Track {
    if (!track.isGeometryLoaded) return track;
    return {
        ...track,
        points: {
            ...track.points,
            [localId]: {
                ...track.points[localId],
                properties: {
                    ...track.points[localId].properties,
                    attr: null,
                },
            },
        },
    };
}
